import type {
  BookingUpdateOfferAcceptWidenApiData,
  BookingUpdateOfferAcceptWidenApiResponses,
  BookingUpdateOfferDeclineApiData,
  BookingUpdateOfferDeclineApiResponses,
  BookingUpdateOfferPublicGetApiData,
  BookingUpdateOfferPublicGetApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getBookingUpdateOfferUrls = {
  getBookingUpdateOfferPublic: dataEndpoint<
    BookingUpdateOfferPublicGetApiData,
    BookingUpdateOfferPublicGetApiResponses
  >({
    getUrl: ({ offerUid }) => apiUrl(`booking-update-offers/${offerUid}/`)
  }),
  postBookingUpdateOfferAcceptWiden: responseEndpoint<
    BookingUpdateOfferAcceptWidenApiData,
    BookingUpdateOfferAcceptWidenApiResponses
  >({
    getUrl: ({ offerUid }) => apiUrl(`booking-update-offers/${offerUid}/accept/`),
    getBody: ({ offerUid: _, ...body }) => body
  }),
  postBookingUpdateOfferDecline: responseEndpoint<
    BookingUpdateOfferDeclineApiData,
    BookingUpdateOfferDeclineApiResponses
  >({
    getUrl: ({ offerUid }) => apiUrl(`booking-update-offers/${offerUid}/decline/`),
    getBody: ({ offerUid: _, ...body }) => body
  })
};
